/** Lista de objetos que contienen información sobre los documentos asociados. */

export default class CommonDocument {
  /** (String): Nombre del archivo del documento. */
  fileName: string

  /** (String): Tipo de documento.
   * 1: anverso
   * 2: reverso
   */
  documentType: string //'1' | '2'

  /** (String) Id del documento */
  documentId: string

  /** (String): Datos del documento en formato string. */
  documentData?: string

  /** (String): Mime type del documento. */
  mimeType?: string

  riskNumber?: string

  constructor(data: any) {
    this.fileName = data.fileName
    this.documentType = data.documentType
    this.documentId = data.documentId
    this.documentData = data.documentData
    this.mimeType = data.mimeType
    this.riskNumber = data.riskNumber ?? undefined
  }
}
